import { useNavigate } from 'react-router-dom'
import { palettePrimaryMain } from '@/theme/designTokens'

import Button from '@mui/material/Button'

export function BackToLoginButton() {
  const navigate = useNavigate()

  return (
    <Button
      type="button"
      variant="outlined"
      fullWidth
      onClick={() => navigate('/login')}
      sx={{
        border: `1.5px solid ${palettePrimaryMain}`,
        borderRadius: '12px',
        py: '16px',
        px: '24px',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 600,
        fontSize: '18px',
        lineHeight: '24px',
        letterSpacing: 0,
        color: palettePrimaryMain,
        textTransform: 'none',
        bgcolor: 'transparent',
        '&:hover': {
          bgcolor: 'rgba(37,99,235,0.06)',
          border: `1.5px solid ${palettePrimaryMain}`,
        },
      }}
    >
      Back to Login
    </Button>
  )
}
